<template>
  <div id="login">
    <transition name="fade">
      <div v-if="performingRequest" class="loading">
        <p class="loading-info">Carregant...</p>
      </div>
    </transition>
    <section class="login-section">
      <div class="columns is-vcentered">
        <div class="column hero zis-primary is-fullheight is-hidden-mobile is-danger">
          <div class="hero-body">
            <div class="container is-centered">
              <p class="title">Suport d'Arrel</p>
              <p class="subtitle">Benvingut/da</p>
            </div>
          </div>
        </div>
        <div
          class="column hero is-fullheight is-vcentered"
          :class="{ 'signup-form': !showLoginForm && !showForgotPassword }"
        >
          <div class="hero-body">
            <section class="is-fullwith">
              <form v-if="showLoginForm" @submit.prevent>
                <h1 class="title">Benvingut/da</h1>

                <label class="label" for="email1">Correu</label>
                <input
                  v-model.trim="loginForm.email"
                  type="text"
                  placeholder="elteu@email.com"
                  id="email1"
                />

                <label class="label" for="password1">Contrasenya</label>
                <input
                  v-model.trim="loginForm.password"
                  type="password"
                  placeholder="******"
                  id="password1"
                />

                <button @click="login" :disabled="loginForm.email == '' || loginForm.password == ''" class="button is-danger">Entra</button>

                <div class="extras">
                  <a class="has-text-danger" @click="togglePasswordReset">He oblidat la meva contrasenya</a>
                  <a class="has-text-danger" @click="toggleForm">Crea un compte</a>
                </div>
              </form>
              <form v-if="!showLoginForm && !showForgotPassword" @submit.prevent>
                <h1 class="title">Comença</h1>

                <label class="label" for="name">Nom</label>
                <input
                  v-model.trim="signupForm.name"
                  type="text"
                  placeholder="Nom del vostre projecte"
                  maxlength="150"
                  id="name"
                />

                <label class="label" for="email2">Correu</label>
                <input
                  v-model.trim="signupForm.email"
                  type="text"
                  placeholder="elvostre@correu.com"
                  id="email2"
                />

                <label class="label" for="password2">Contrasenya</label>
                <input
                  v-model.trim="signupForm.password"
                  type="password"
                  placeholder="mín 6 caràcters"
                  id="password2"
                />

                <!-- <label class="label" for="userName">Comarca</label>
                <div class="select zis-primary">
                <select v-model="signupForm.territorial">
                  <option
                    v-for="t in territorials"
                    :value="t.id"
                    v-bind:key="t.id"
                  >{{ t.description }}</option>
                </select>
                </div> -->
                
                <!-- <label class="label" for="email2">Població</label>
                <input
                  v-model.trim="signupForm.city"
                  type="text"
                  placeholder="on vius"
                  id="onvius"
                />                 -->

                <button @click="signup" class="button is-danger">Registra't</button>

                <div class="extras">
                  <a class="has-text-danger" @click="toggleForm">Ja tens usuària? Ves al login</a>
                </div>
              </form>
              <form v-if="showForgotPassword" @submit.prevent class="password-reset">
                <div v-if="!passwordResetSuccess">
                  <h1 class="title">Resseteja la contasenya</h1>
                  <p style="margin-bottom:1rem">T'enviarem un correu per poder canviar la teva contasenya</p>

                  <label class="label" for="email3">Email</label>
                  <input
                    v-model.trim="passwordForm.email"
                    type="text"
                    placeholder="elteu@email.com"
                    id="email3"
                  />

                  <button @click="resetPassword" class="button is-danger">Envia</button>

                  <div class="extras">
                    <a class="has-text-danger" @click="togglePasswordReset">Ves al login</a>
                  </div>
                </div>
                <div v-else>
                  <h1 class="title">Email Sent</h1>
                  <p>check your email for a link to reset your password</p>
                  <button @click="togglePasswordReset" class="button is-danger">Back to login</button>
                </div>
              </form>

              <transition name="fade">
                <section v-if="errorMsg !== ''" class="zcolumns is-fullwith">
                  <div class="error-msg zcolumn is-full">
                    <p>{{ errorMsg }}</p>
                  </div>
                </section>
              </transition>
            </section>
          </div>
        </div>
      </div>
      <!-- <div class="col1">
                <h1>Vuegram</h1>
                <p>Welcome to the <a href="https://savvyapps.com/" target="_blank">Savvy Apps</a> sample social media web app powered by Vue.js and Firebase.
                    Build this project by checking out The Definitive Guide to Getting Started with Vue.js</p>
            </div>
            <div class="col2" :class="{ 'signup-form': !showLoginForm && !showForgotPassword }">
                
      </div>-->
    </section>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { territorial } from "../services/territorial.service";

export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      signupForm: {
        name: "",        
        email: "",
        password: "",
        territorial: "",
        city: ""
      },
      passwordForm: {
        email: ""
      },
      showLoginForm: false,
      showForgotPassword: false,
      passwordResetSuccess: false,
      performingRequest: false,
      errorMsg: "",
      territorials: territorial
    };
  },
  methods: {
    toggleForm() {
      this.errorMsg = "";
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      if (this.showForgotPassword) {
        this.showLoginForm = true;
        this.showForgotPassword = false;
        this.passwordResetSuccess = false;
      } else {
        this.showLoginForm = false;
        this.showForgotPassword = true;
      }
    },
    login() {
      this.performingRequest = true;

      fb.auth
        .signInWithEmailAndPassword(
          this.loginForm.email,
          this.loginForm.password
        )
        .then(user => {
          
          this.$store.commit("setCurrentUser", user.user);
          this.$store.dispatch("fetchUserProfile");
          this.performingRequest = false;
          this.$router.push("/perfil");
            
          
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    signup() {
      this.performingRequest = true;

      fb.auth
        .createUserWithEmailAndPassword(
          this.signupForm.email,
          this.signupForm.password
        )
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);

          // localStorage.setItem('signInEmail', this.signupForm.email)
          // localStorage.setItem('signInName', this.signupForm.name)
          // localStorage.setItem('signInUserName', this.signupForm.userName)

          // create user obj
          fb.usersCollection
            .doc(user.user.uid)
            .set({
              name: this.signupForm.name,
              email: this.signupForm.email,
              city: this.signupForm.city,
              territorial: this.signupForm.territorial,
              role: 'user',
            })
            .then(() => {

              const actionCodeSettings = {            
                url: `${process.env.URLBASE}/perfil`,
                handleCodeInApp: true
              };

              user.user.sendEmailVerification(actionCodeSettings);

              this.$store.dispatch("fetchUserProfile");
              this.performingRequest = false;
              this.$router.push("/verify");
            })
            .catch(err => {
              console.log(err);
              this.performingRequest = false;
              this.errorMsg = err.message;
            });
          
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    resetPassword() {
      this.performingRequest = true;

      fb.auth
        .sendPasswordResetEmail(this.passwordForm.email)
        .then(() => {
          this.performingRequest = false;
          this.passwordResetSuccess = true;
          this.passwordForm.email = "";
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    }
  }
};
</script>
<style scoped>
.extras{
  margin-top: 2rem;
}
.extras a{
  display: block;
  margin-bottom:1rem;
}
.loading-info{
  font-family: 'Varela Round';
}
.login-section{
  margin-top: -10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue